import { z } from "zod";

export const AD_PACKAGE_KEYS = [
  "BASIC",
  "GENERAL",
  "PREMIUM",
  "PLATINUM",
] as const;

export const AD_PACKAGE_KEY_SCHEMA = z.enum(AD_PACKAGE_KEYS, "Invalid package key");

export type AdPackageKey = z.infer<typeof AD_PACKAGE_KEY_SCHEMA>;